<template>
  <!-- Модальное окно подтверждения удаления -->
  <UModal
    v-model:open="modelValue"
    overlay
    title="Подтверждение удаления"
    ref="modal"
  >
    <!-- Сообщение с предупреждением -->
    <template #body>
      <p>Вы уверены, что хотите удалить эту заметку?</p>
    </template>

    <!-- Кнопки действий -->
    <template #footer>
      <UButton
        variant="solid"
        color="warning"
        icon="i-lucide-trash"
        @click="$emit('confirm')"
      >
        Удалить
      </UButton>
      <UButton
        variant="solid"
        color="secondary"
        icon="i-lucide-x"
        @click="modelValue = false"
      >
        Отмена
      </UButton>
    </template>
  </UModal>
</template>

<script setup lang="ts">
// Определяем события компонента
defineEmits(["confirm", "cancel"]);

// Модель видимости модального окна (v-model)
const modelValue = defineModel<boolean>();
</script>
